import Events from '@/api/events'

export default (error, path) => {
  var status, message

  if (error.response) {
    status = error.response.status
    message = error.response.statusText
  } else {
    status = 0
    message = 'Unknown error'
    console.log('Error: ', JSON.stringify(error))
  }

  Events.$emit('toggleLoading', false)

  switch (status) {
    case 400:
      Events.$emit('error', 'A bad request was sent to the server.')
      window.location = '/'
      break
    case 401:
      Events.$emit('error', 'You are not logged in.')
      Events.$emit('toLogin')
      break
    case 403:
      Events.$emit('error', 'Access to this page is forbidden.')
      window.location = '/'
      break
    case 404:
      Events.$emit('error', 'The page you requested was not found.')
      break
    case 406:
      Events.$emit('error', 'Invalid data entered.')
      break
    case 409:
      Events.$emit('error', 'Duplicate record was entered.')
      break
    default:
      console.log('Error: ', status, message, path)
  }
}



// WEBPACK FOOTER //
// ./src/api/errors.js